import { getStorageUser } from './Auth';

const mapping = {
  EVENT: 'event',
  PAGE: 'page',
  PAGENAME: 'pagename',
  USERID: 'userID',
  ORGANIZATION: 'organizacion',
  SEGMENT: 'segmento',
  PROFILE: 'profile',
  RATEPLAN: 'ratePlan',
  EVENTCATEGORY: 'evento-interactivo-categoria',
  EVENTACTION: 'evento-interactivo-accion',
  EVENTTAG: 'evento-interactivo-etiqueta',
  ECOMMERCE: 'ecommerce',
  NUMERODOCUMENTO: 'numeroDocumento',
  PAGEPATHINTENT: 'page_path_intent',
  VDITARGETPLAN: 'vdi-target-plan',
  NETWORKISSUES: 'reporte-network-issues',
  PLANCODE: 'planCode',
  PLANNAME: 'planName',
  PLANPRICE: 'planPrice',
  NAMEUSER: 'nameUser',
};

const mapParams = params =>
  Object.fromEntries(
    Object.entries(params).map(([key, val]) => [
      mapping[key.toUpperCase()] ?? key,
      val,
    ])
  );

const pushToDataLayer = params => {
  if (
    typeof window !== 'undefined' &&
    typeof window.dataLayer !== 'undefined'
  ) {
    const user = getStorageUser();
    const paramsCloned = { ...params };

    if (params.page !== '/' && user) {
      paramsCloned.userId = user.plan.number;
      paramsCloned.organization = user.user.isCorporate ? 'Si' : 'No';
      paramsCloned.segment = user.plan.segment;
      paramsCloned.profile = user.plan.profile;
      paramsCloned.ratePlan = user.plan.ratePlan;
    }
    const paramsMapped = mapParams(paramsCloned);

    window.dataLayer.push(paramsMapped);
  }

  return null;
};

const tagInteractiveEvent = ({ eventCategory, eventAction, eventTag }) => {
  return pushToDataLayer({
    event: 'evento-interactivo',
    'evento-interactivo-categoria': eventCategory,
    'evento-interactivo-accion': eventAction,
    'evento-interactivo-etiqueta': eventTag,
  });
};

const GoogleTagManager = {
  pushToDataLayer,
  tagInteractiveEvent,
};

export default GoogleTagManager;
